export const UNVERIFIED_EMAILS_RESULT_TYPES = {
  UNSUPPORTED_PROPERTY_TYPE: 'UNSUPPORTED_PROPERTY_TYPE',
  UNSUPPORTED_OBJECT_TYPE: 'UNSUPPORTED_OBJECT_TYPE',
  UPSTREAM_EXCEPTION: 'UPSTREAM_EXCEPTION',
  VALIDATION_TASK_ENQUEUED: 'VALIDATION_TASK_ENQUEUED',
  VALIDATION_TASK_RUNNING: 'VALIDATION_TASK_RUNNING',
  NO_PERSONALIZATION_TOKEN: 'NO_PERSONALIZATION_TOKEN',
  SUCCESS: 'SUCCESS',
  AUTOMATED_UNCHECKED: 'AUTOMATED_UNCHECKED'
};